import { createContext } from 'react';
import { Tag } from 'shared/types/tag';

export type DeleteTagContextProps = {
  openDeleteTag: (tag: Tag) => void;
};

export const DeleteTagContext = createContext<DeleteTagContextProps>({
  openDeleteTag: () => {},
});
